'use client';

import { PersonalBrandBotPage } from '../../../features/personal-brand-bot';

interface PersonalBrandBotContentProps {
  locale: string;
}

export function PersonalBrandBotContent({ locale }: PersonalBrandBotContentProps) {
  return <PersonalBrandBotPage locale={locale} />;
}
